export * from './admin-glossary-info.component';
